import {useContext} from 'react';
import type {ConfigContextValue} from '../contexts/ConfigContext';
import ConfigContext from '../contexts/ConfigContext';

const useConfig = (): ConfigContextValue => useContext(ConfigContext);

export default useConfig;
